import React from 'react'
import './useCaseSection.scss'

const UseCaseSection = () => {
  return (
    <div className="use_case__section">
      <div className="use_case__wrapper">
        <div className={"phone_numbers"}>
          <p className=" ">USA 1 (888)846-7655</p>
          <p className=" ">Jamaica 1 (876)960-1004</p>
          <p className=" ">Cayman Island 1 (345) 749-8391</p>
          <p className=" ">Trinidad 1 (868) 224-5709</p>
        </div>
        <h5 className="use_case__section__wrapper__heading primary__heading">With Virtual Office You Recieve:</h5>

        <p className="use_case__section__wrapper__paragraph">
          &#10004; &nbsp; &nbsp; Flexible Pricing
        </p>
        <p className="use_case__section__wrapper__paragraph">
          &#10004; &nbsp; &nbsp; 24/7 Availability
        </p>
        <p className="use_case__section__wrapper__paragraph">
          &#10004; &nbsp; &nbsp; Good Reputation
        </p>
        <p className="use_case__section__wrapper__paragraph">
          &#10004; &nbsp; &nbsp; Amazing Customer Support
        </p>
        <p className="use_case__section__wrapper__paragraph">
          &#10004; &nbsp; &nbsp; Proficient &#38; Happy Operators</p>
        <p className="use_case__section__wrapper__paragraph">
          &#10004; &nbsp; &nbsp; Minimal Hold Times
        </p>
      </div>
    </div>
  )
}

export default UseCaseSection
